import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export type EntityHeroAccent = 'online' | 'offline' | 'take' | 'none';

interface EntityHeroCardProps {
	title: ReactNode;
	subtitle?: ReactNode;
	trailing?: ReactNode;
	accent?: EntityHeroAccent;
	className?: string;
}

const ACCENT_STYLES: Record<EntityHeroAccent, string | undefined> = {
	online: 'border-l-chart-2',
	offline: 'border-l-chart-5',
	take: 'border-l-[#ad46ff]',
	none: undefined,
};

export function OnlineStatusBadge({ isOnline }: { isOnline: boolean }) {
	if (isOnline) {
		return (
			<span className='text-chart-2 flex items-center gap-1 text-xs font-semibold'>
				<span className='bg-chart-2 w-2 h-2 animate-pulse rounded-full' />
				Онлайн
			</span>
		);
	}
	return <span className='text-chart-5 text-xs font-semibold'>Офлайн</span>;
}

export default function EntityHeroCard({ title, subtitle, trailing, accent = 'none', className }: EntityHeroCardProps) {
	const accentStyle = ACCENT_STYLES[accent];

	return (
		<div
			className={cn(
				'bg-card border border-border rounded-md px-3 py-2.5 flex items-center justify-between gap-3',
				accentStyle && 'border-l-2',
				accentStyle,
				className,
			)}
		>
			<div className='min-w-0 flex-1'>
				<div className='text-sm font-semibold truncate'>{title}</div>
				{subtitle != null && subtitle !== '' && (
					<div className='text-xs text-muted-foreground mt-0.5 truncate'>{subtitle}</div>
				)}
			</div>
			{trailing != null && <div className='shrink-0'>{trailing}</div>}
		</div>
	);
}
